module.exports = __webpack_public_path__ + "img/technology-13.d260d276.png";